"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                FileUpload_BrowseButtonLabel: "Browse",
                FileUpload_CancelButtonlabel: "Cancel",
                FileUpload_ExtensionError: "Please select a file with one of the following extensions: {0}",
                FileUpload_Failed: "File upload is failed",
                FileUpload_FileNameInputLabel: "File Upload Control File Name",
                FileUpload_InvalidStrategyClass: "The FileUpload Strategy Class you selected does not exist.",
                FileUpload_LessThanMinError: "File cannot be less than {0} in size",
                FileUpload_MoreThanMaxError: "File cannot be greater than {0} in size",
                FileUpload_Started: "File upload is started",
                FileUpload_Success: "File upload is successful",
                FileUpload_UploadButtonLabel: "Upload",
            },
        });
        var FileInputSelector = ".fileUpload-fileInput";
        var FileUpload = /** @class */ (function (_super) {
            __extends(FileUpload, _super);
            function FileUpload(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                _this.BrowseButtonClicked = function () {
                    $dyn.observe($dyn.util.hasJQueryFileUploadLoaded, function (value) {
                        if (value) {
                            // For each request , destoy and rebuild. There are probably better ways, but this is the safest.
                            _this.setupJqUploader();
                            // Because the change of the file in the filePicker(FileInputControl) will trigger the handler this.FileChanged(fileInput).
                            // For the mimimal and MimimalWithFileName style, set the value as empty. If users pick the same file, it still trigger the change handler.
                            _this.jqUploaderElement.val("");
                            try {
                                _this.jqUploaderElement.click();
                            }
                            catch (err) {
                                $dyn.showMessageBox({
                                    showOkButton: true,
                                    Text: $dyn.format($dyn.label("DocumentUpload_FileAccessError"), err.message)
                                });
                                // Dismiss the dialog and refresh the page when the Ok button is clicked
                                var okButton = $.find('[data-dyn-controlname="Ok"]')[0];
                                okButton.addEventListener("click", function () {
                                    $dyn.shell.dialogBack();
                                    location.reload(true);
                                });
                            }
                            return false;
                        }
                    });
                };
                _this.SubmitButtonClicked = function () {
                    if (_this.submitDriver) {
                        _this.submitDriver();
                    }
                };
                _this.CancelButtonClicked = function () {
                    if (_this.jqXHR) {
                        _this.jqXHR.abort();
                    }
                    if (_this.CloseDialog) {
                        _this.CloseDialog();
                    }
                };
                // the acceptFileTypes option does not give the chance to display message in auto upload mode
                _this.onFileAdded = function (e, data) {
                    // The fileupload widget replaces the input element on the fly to allow uploading the same
                    // file multiple times, so we need to update it.
                    _this.jqUploaderElement = _this.myContainer.find(FileInputSelector);
                    var fname = data.files[0].name;
                    var sz = data.files[0].size;
                    var clientMax = _this.maxSizeBytes();
                    var errorMsg = "";
                    var label = "onFileAdded";
                    if (!_this.IsFileTypeValid(data.files[0])) {
                        errorMsg = $dyn.label("FileUpload_ExtensionError").replace("{0}", $dyn.value(_this.CommonFileTypesAccepted));
                        label = "FileUpload_ExtensionError";
                    }
                    else if ($dyn.value(_this.StrategyClassName).trim() === "") {
                        errorMsg = $dyn.label("FileUpload_InvalidStrategyClass");
                        label = "FileUpload_InvalidStrategyClass";
                    }
                    else if (sz < _this.minSizeBytes()) {
                        errorMsg = $dyn.label("FileUpload_LessThanMinError").replace("{0}", _this.formatSize(_this.minSizeBytes()));
                        label = "FileUpload_LessThanMinError";
                    }
                    else if (sz > clientMax) {
                        errorMsg = $dyn.label("FileUpload_MoreThanMaxError").replace("{0}", _this.formatSize(clientMax));
                        label = "FileUpload_MoreThanMaxError";
                    }
                    if (errorMsg !== "") {
                        $dyn.errorMessageBox({ Text: errorMsg, Label: label });
                        return;
                    }
                    if (_this.ShouldUploadImmediately()) {
                        $dyn.setValue(_this, "FileName", fname);
                        _this.fileNameDisplayValue(fname);
                        _this.startFileUpload(data, e);
                    }
                    else {
                        $dyn.setValue(_this, "FileName", fname);
                        _this.fileNameDisplayValue(fname);
                        _this.submitDriver = function () {
                            _this.startFileUpload(data, e);
                        };
                    }
                };
                _this.onUploadFinished = function (e, data) {
                    _this.finishFileUpload();
                    $dyn.async.pending.decrement("Upload file complete");
                    if (data && data.result) {
                        var uploadResult = _this.ParseResult(data);
                        if (uploadResult) {
                            _this.ProgressPercent(100);
                            if (_this.UploadWasSuccessful) {
                                _this.UploadWasSuccessful(uploadResult);
                            }
                        }
                        else if (_this.UploadFailed) {
                            _this.UploadFailed();
                        }
                    }
                    if ($dyn.value(_this.browseEnabled)) {
                        _this.setFocusBack();
                    }
                };
                /**
                 * Update progress bar during upload.
                 * @param e The event object.
                 * @param data The progress object.
                 */
                _this.onProgressUpdate = function (e, data) {
                    if (data.loaded < data.total) {
                        _this.ProgressPercent(Math.round(data.loaded / data.total * 100));
                    }
                };
                _this.onUploadFailed = function (e, data) {
                    _this.finishFileUpload();
                    $dyn.async.pending.decrement("Upload file failed");
                    if (_this.UploadFailed && data.errorThrown !== "abort") {
                        _this.UploadFailed(data.errorThrown);
                    }
                };
                _this.ProgressPercent = $dyn.observable(0);
                // Load the jQuery file upload control file ondemand
                $dyn.util.loadJQueryFileUpload();
                // control display properties
                _this.fileNameDisplayValue = $dyn.observable("");
                _this.fileuploadInProgress = $dyn.observable(false);
                _this.ProgressPercentText = $dyn.computed(function () { return $dyn.value(_this.ProgressPercent) + "%"; });
                _this.DisplayProgressBar = $dyn.computed(function () { return $dyn.value(_this.fileuploadInProgress) || $dyn.value(_this.ProgressPercent) === 100; });
                _this.UploadButtonEnabled = $dyn.computed(function () {
                    var fileName = $dyn.value(_this.FileName);
                    var enabled = !$dyn.value(_this.IsViewMode)
                        && (fileName.trim() !== "");
                    return (!$dyn.value(_this.fileuploadInProgress) && enabled);
                });
                _this.cancelEnabled = $dyn.computed(function () { return (!$dyn.value(_this.IsViewMode)) && $dyn.value(_this.Enabled); });
                _this.browseEnabled = $dyn.computed(function () { return (!$dyn.value(_this.IsViewMode)) && $dyn.value(_this.Enabled) && (!$dyn.value(_this.fileuploadInProgress)); });
                $.when($dyn.deferred.onTrue(function () { return ($dyn.value($dyn.async.pending) === 0); }))
                    .done(function () {
                    if (!$dyn.value(_this.BrowseText)) {
                        $dyn.setValue(_this, "BrowseText", $dyn.label("FileUpload_BrowseButtonLabel"));
                    }
                });
                $dyn.observe(_this.FileName, function (newValue) {
                    var fileName = $dyn.util.parseFileNameWithDirectory(newValue);
                    _this.fileNameDisplayValue(fileName);
                });
                _this.runtimeParameters = [];
                _this.submitDriver = null;
                _this.myContainer = $(element);
                _this.jqUploaderElement = _this.myContainer.find(FileInputSelector);
                return _this;
            }
            FileUpload.prototype.dispose = function () {
                this.reset && this.reset();
                _super.prototype.dispose.call(this);
            };
            FileUpload.prototype.maxSizeBytes = function () {
                var maxFileSizeMB = $dyn.value(this.MaxFileSizeInMegaBytes);
                if (maxFileSizeMB < 0) {
                    // if a max file is not specified in the strategy class,
                    // it may be defined as less than 0
                    // that value should represent the default
                    maxFileSizeMB = $dyn.controls.documentConstants.FILE_UPLOAD_MAX_BLOB_SIZE;
                }
                return maxFileSizeMB * Math.pow(1024, 2);
            };
            FileUpload.prototype.minSizeBytes = function () {
                return $dyn.value(this.MinFileSizeInMegaBytes) * Math.pow(1024, 2);
            };
            /**
             * Determines if the picked file has a valid type.
             * @param file The file to check.
             * @returns A value indicating if the picked file has a valid type.
             */
            FileUpload.prototype.IsFileTypeValid = function (file) {
                if (this.IsFileTypesFilterValid) {
                    var fileExt = $dyn.util.GetFileExtension(file.name);
                    return $dyn.util.CheckValidFileExtension(fileExt, file.type, $dyn.value(this.CommonFileTypesAccepted));
                }
                else {
                    return false;
                }
            };
            /** All setups related to the JQ uploader. */
            FileUpload.prototype.setupJqUploader = function () {
                var e_1, _a;
                var _this = this;
                this.reset();
                this.jqUploaderElement = this.myContainer.find(FileInputSelector);
                // add a unique client id
                this.setParamToUploader("clientId", $dyn.util.generatePseudoId());
                this.setParamToUploader("maxChunkSize", $dyn.controls.documentConstants.DEFAULT_CHUNK_SIZE);
                this.setParamToUploader("max", this.maxSizeBytes());
                this.setParamToUploader("min", this.minSizeBytes());
                this.setParamToUploader("strategyClassName", $dyn.value(this.StrategyClassName));
                this.setParamToUploader("fileMetaData", $dyn.value(this.FileMetaData));
                this.setParamToUploader("isFileTypesFilterValid", $dyn.value(this.IsFileTypesFilterValid));
                this.setParamToUploader("commonFileTypesAccepted", $dyn.value(this.CommonFileTypesAccepted));
                this.setParamToUploader("formName", this.Root !== undefined ? this.Root.FormName : "");
                // add all misc params
                if (this.AdditionalParameters) {
                    try {
                        for (var _b = __values(this.AdditionalParameters), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var targetParam = _c.value;
                            if (targetParam.Key) {
                                this.setParamToUploader(targetParam.Key, targetParam.Value);
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                this.jqUploaderElement.fileupload({
                    add: this.onFileAdded,
                    beforeSend: function (request) {
                        $dyn.serverForm.setCsrfToken(request);
                        request.setRequestHeader($dyn.serverForm.RequestHeaderKeys.clientSessionKey, $dyn.browserActivity.BrowserSessionActivity.Id);
                    },
                    dataType: "json",
                    disableImageResize: false,
                    done: this.onUploadFinished,
                    fail: this.onUploadFailed,
                    formData: this.runtimeParameters,
                    imageMaxHeight: $dyn.value(this.ImageMaxHeight),
                    imageMaxWidth: $dyn.value(this.ImageMaxWidth),
                    limitConcurrentUploads: 3,
                    loadImageMaxFileSize: this.maxSizeBytes(),
                    loadImageMinFileSize: this.minSizeBytes(),
                    maxChunkSize: $dyn.controls.documentConstants.DEFAULT_CHUNK_SIZE,
                    progressall: this.onProgressUpdate,
                    url: $dyn.util.resolveVirtualPath(this.UploadUrl),
                    // Pass in a method to provide an XHR request
                    // JQX is binding "progress" to the request object but never unbinding it,
                    // which causes a memory leak.
                    xhr: function () {
                        _this.xhr = $.ajaxSettings.xhr();
                        return _this.xhr;
                    },
                });
            };
            FileUpload.prototype.ShouldUploadImmediately = function () {
                var style = $dyn.value(this.Style);
                return style === $dyn.ui.FileUploadStyle.MinimalStyle || style === $dyn.ui.FileUploadStyle.MinimalWithFileNameStyle;
            };
            FileUpload.prototype.setFocusToItem = function (itemName) {
                itemName = "" + this.Name + itemName;
                var $item = $(this.element).find("[data-dyn-controlname='" + itemName + "']");
                $item.focus();
                $dyn.log.focus && $dyn.log.focus("Focus: FileUpload setFocusToItem: %s", itemName);
            };
            FileUpload.prototype.setFocusBack = function () {
                switch ($dyn.value(this.Style)) {
                    case $dyn.ui.FileUploadStyle.MinimalStyle:
                        if ($dyn.value(this.browseEnabled)) {
                            this.setFocusToItem("BrowseButton");
                        }
                        break;
                    case $dyn.ui.FileUploadStyle.MinimalWithFileNameStyle:
                        if ($dyn.value(this.browseEnabled)) {
                            this.setFocusToItem("BrowseButton");
                        }
                        else {
                            this.setFocusToItem("FileNameDisplay");
                        }
                        break;
                    default: // Standard Style
                        if ($dyn.value(this.browseEnabled)) {
                            this.setFocusToItem("BrowseButton");
                        }
                        else if ($dyn.value(this.cancelEnabled)) {
                            this.setFocusToItem("CancelButton");
                        }
                        else if ($dyn.value(this.UploadButtonEnabled)) {
                            this.setFocusToItem("UploadButton");
                        }
                        else {
                            this.setFocusToItem("FileNameDisplay");
                        }
                        break;
                }
            };
            FileUpload.prototype.startFileUpload = function (data, e) {
                $dyn.async.pending.increment("Upload file starting");
                this.fileuploadInProgress(true);
                this.setAriaLabel($dyn.label("FileUpload_Started"));
                this.setFocusBack();
                $dyn.applyFunction(this.OnUploadAttemptStarted);
                $.blueimp.fileupload.prototype.options.add.call(this.jqUploaderElement, e, data);
                this.jqXHR = data;
            };
            /**
             * Callback for when the upload is successful
             * @param uploadResult The result of the upload.
             */
            FileUpload.prototype.UploadWasSuccessful = function (uploadResult) {
                $dyn.setValue(this, "FileUploadResult", uploadResult);
                this.setAriaLabel($dyn.label("FileUpload_Success"));
                $dyn.setValue(this, "Value", uploadResult);
                $dyn.applyFunction(this.OnUploadCompleted);
            };
            /** Callback for when the upload fails. */
            FileUpload.prototype.UploadFailed = function (error) {
                this.setAriaLabel($dyn.label("FileUpload_Failed"));
                $dyn.applyFunction(this.OnUploadCompleted);
            };
            FileUpload.prototype.ParseResult = function (data) {
                return JSON.parse(data.result[0]);
            };
            FileUpload.prototype.finishFileUpload = function () {
                this.fileuploadInProgress(false);
                if (this.xhr && this.xhr.upload) {
                    $(this.xhr.upload).off("progress");
                }
                this.xhr = null;
                this.jqXHR = null;
            };
            FileUpload.prototype.setParamToUploader = function (k, v) {
                var e_2, _a;
                var newPair;
                var foundit = false;
                try {
                    for (var _b = __values(this.runtimeParameters), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var parameter = _c.value;
                        if (parameter.name === k) {
                            // found it
                            parameter.value = v;
                            foundit = true;
                            break;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                if (!foundit) {
                    newPair = {};
                    newPair.name = k;
                    newPair.value = v;
                    this.runtimeParameters.push(newPair);
                }
            };
            FileUpload.prototype.setAriaLabel = function (label) {
                if (this.element) {
                    this.element.setAttribute("aria-busy", "true");
                    this.element.setAttribute("aria-label", label);
                    this.element.setAttribute("aria-busy", "false");
                }
            };
            FileUpload.prototype.formatSize = function (bytes) {
                var i = -1;
                do {
                    bytes = bytes / 1024;
                    i++;
                } while (bytes > 99);
                return Math.max(bytes, 0.1).toFixed(1) + FileUpload.sizeSymbols[i];
            };
            FileUpload.prototype.resetUx = function () {
                this.ProgressPercent(0);
                this.submitDriver = null;
                this.fileuploadInProgress(false);
                this.jqUploaderElement = null;
            };
            FileUpload.prototype.reset = function () {
                this.resetUx();
                try {
                    this.jqUploaderElement.fileupload("destroy");
                }
                catch (ex) { /* no-op */ }
            };
            FileUpload.sizeSymbols = ["kB", "MB", "GB", "TB", "PB", "EB"];
            return FileUpload;
        }($dyn.ui.Control));
        controls.FileUpload = FileUpload;
        FileUpload.prototype.FileNameLabel = "";
        FileUpload.prototype.StrategyClassName = "";
        FileUpload.prototype.CommonFileTypesAccepted = "";
        FileUpload.prototype.IsFileTypesFilterValid = true;
        FileUpload.prototype.UploadUrl = "/fileUpload";
        FileUpload.prototype.MaxFileSizeInMegaBytes = $dyn.controls.documentConstants.FILE_UPLOAD_MAX_BLOB_SIZE;
        FileUpload.prototype.MinFileSizeInMegaBytes = -1;
        FileUpload.prototype.AdditionalParameters = [];
        FileUpload.prototype.BrowseText = "";
        FileUpload.prototype.Style = "";
        FileUpload.prototype.OnUploadAttemptStarted = null;
        FileUpload.prototype.OnUploadCompleted = null;
        FileUpload.prototype.CloseDialog = null;
        FileUpload.prototype.FileName = "";
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=FileUpload.js.map
